import React from 'react';
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text
} from '@chakra-ui/react';

export const LONG_TEXT_MESSAGE =
  "Your profile contains a lot of text. It's best to keep it to about 100-150 words. Would you like me to try and summarise your profile?";

// Closing the modal (X, Esc or overlay) cancels the save.
const LongTextModal = ({ isOpen, canSummarise, onSummarise, onSaveAnyway, onCancel }) => (
  <Modal isOpen={isOpen} onClose={onCancel} isCentered>
    <ModalOverlay />
    <ModalContent>
      <ModalCloseButton />
      <ModalBody pt={10}>
        <Text>{LONG_TEXT_MESSAGE}</Text>
      </ModalBody>
      <ModalFooter>
        <HStack spacing={3}>
          {canSummarise && (
            <Button colorScheme="blue" onClick={onSummarise}>
              Summarise
            </Button>
          )}
          <Button colorScheme="blue" variant="outline" onClick={onSaveAnyway}>
            Save Anyway
          </Button>
        </HStack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default LongTextModal;
